module.exports = __webpack_public_path__ + "img/saudiarabia.53b10a5f.svg";